import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AriAvatar from 'containers/Ari/AriAvatar';
import { trackEvent } from 'helpers/Analytics';
import { getApplyAriPath } from 'helpers/applyAriDraft';
import styles from './BriefDetailsSignUp.module.scss';

/**
 * Apply with Ari CTA card (TP-498) — matches design:
 * heading "Apply in 1–2 minutes", Ari callout, blue CTA, Terms only.
 */
const BriefDetailsApplyWithAri = ({ routeId, popularityWarning = false }) => {
  const to = getApplyAriPath(routeId);

  const handleClick = () => {
    trackEvent('apply-ari-cta-click', { briefRouteId: String(routeId || '') });
  };

  return (
    <div className={styles.card} data-testid="apply-with-ari-card">
      <h2 className={styles.heading}>Apply in 1–2 minutes</h2>

      <div className={styles.ariCallout}>
        <AriAvatar size={36} className={styles.ariCalloutAvatar} />
        <p className={styles.ariCalloutText}>
          Ari drafts your application for you. No forms to fill in.
        </p>
      </div>

      {popularityWarning && (
        <div className={styles.notice} role="status">
          <p className={styles.noticeText}>
            This job has reached its application limit for free accounts. Twine
            Pro members can still apply.{' '}
            <a href="/pricing/creative">See plans</a>
          </p>
        </div>
      )}

      <Link
        className={styles.ariCta}
        to={to}
        onClick={handleClick}
        data-testid="apply-with-ari-cta"
      >
        Apply with Ari →
      </Link>

      <p className={styles.ariTerms}>
        By applying, you agree to our <a href="/terms">Terms</a>.
      </p>
    </div>
  );
};

BriefDetailsApplyWithAri.propTypes = {
  routeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  popularityWarning: PropTypes.bool,
};

export default BriefDetailsApplyWithAri;
